// extracted by mini-css-extract-plugin
export default {"loader":"SelectType_loader__9ajCY"};